import "../screens/Dashboard.css";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { ImagePath } from "../helper/ImagePath";

// const socialPlatforms = [

//     { key: "facebook", icon: ImagePath.social1 },
//     { key: "email", icon: ImagePath.social2 },
//     { key: "twitter", icon: ImagePath.social3 },
//     { key: "instagram", icon: ImagePath.social4 },
//     { key: "youtube", icon: ImagePath.social5 },
//     { key: "telegram", icon: ImagePath.social6 },
//     { key: "whatsapp", icon: ImagePath.social7 },
// ];

// const SharePopup = ({
//     isOpen,
//     onClose,
//     shareUrl,
//     message = "",
//     title = "Share Marketing Material",              // ✅ static, overridable
//     subtitle = "Share this marketing creative with your clients, prospects, or network.", // ✅ static, overridable
// }) => {
//     const [copied, setCopied] = useState(false);

//     if (!isOpen) return null;

//     const handleCopyLink = async () => {
//         try {
//             await navigator.clipboard.writeText(shareUrl);
//             setCopied(true);
//             setTimeout(() => setCopied(false), 2000);
//         } catch (err) {
//             console.log("Copy failed", err);
//         }
//     };

//     const handleSocialShare = (platform) => {
//         const text = `${message} ${shareUrl}`.trim();

//         switch (platform) {
//             case "facebook":
//                 window.open(
//                     `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
//                         shareUrl
//                     )}&quote=${encodeURIComponent(message)}`,
//                     "_blank",
//                     "noopener,noreferrer"
//                 );
//                 break;
//             case "email":
//                 window.location.href = `mailto:?subject=${encodeURIComponent(
//                     "Check this out"
//                 )}&body=${encodeURIComponent(text)}`;
//                 break;
//             case "twitter":
//                 window.open(
//                     `https://twitter.com/intent/tweet?text=${encodeURIComponent(
//                         message
//                     )}&url=${encodeURIComponent(shareUrl)}`,
//                     "_blank",
//                     "noopener,noreferrer"
//                 );
//                 break;
//             case "instagram":
//                 navigator.clipboard?.writeText(text).catch(() => { });
//                 window.open("https://www.instagram.com/", "_blank", "noopener,noreferrer");
//                 break;
//             case "youtube":
//                 navigator.clipboard?.writeText(text).catch(() => { });
//                 window.open("https://www.youtube.com/", "_blank", "noopener,noreferrer");
//                 break;
//             case "telegram":
//                 window.open(
//                     `https://t.me/share/url?url=${encodeURIComponent(
//                         shareUrl
//                     )}&text=${encodeURIComponent(message)}`,
//                     "_blank",
//                     "noopener,noreferrer"
//                 );
//                 break;
//             case "whatsapp":
//                 window.open(
//                     `https://wa.me/?text=${encodeURIComponent(text)}`,
//                     "_blank",
//                     "noopener,noreferrer"
//                 );
//                 break;
//             default:
//                 break;
//         }
//     };

//     const content = (
//         <div className="share-popup-overlay" onClick={onClose}>
//             <div className="share-popup" onClick={(e) => e.stopPropagation()}>
//                 <button className="share-popup-close" onClick={onClose}>
//                     &times;
//                 </button>
//                 <div className="icon">
//                     <img src={ImagePath.share_icon} alt="" />
//                 </div>
//                 <h3>{title}</h3>
//                 <p>{subtitle}</p>
//                 <div className="form-group">
//                     <input type="text" className="form-control" value={shareUrl} readOnly />
//                     <button className="btun" onClick={handleCopyLink}>
//                         {copied ? "Copied" : "Copy Link"}
//                     </button>
//                 </div>
//                 <p>Or share via</p>
//                 <ul>
//                     {socialPlatforms.map(({ key, icon }) => (
//                         <li key={key}>
//                             <a
//                                 href="#"
//                                 onClick={(e) => {
//                                     e.preventDefault();
//                                     handleSocialShare(key);
//                                 }}
//                             >
//                                 <img src={icon} alt={key} />
//                             </a>
//                         </li>
//                     ))}
//                 </ul>
//             </div>
//         </div >
//     );

//     return ReactDOM.createPortal(content, document.body);
// };

// export default SharePopup;





const socialPlatforms = [
    { key: "facebook", icon: ImagePath.social1 },
    { key: "email", icon: ImagePath.social2 },
    { key: "twitter", icon: ImagePath.social3 },
    { key: "instagram", icon: ImagePath.social4 },
    { key: "youtube", icon: ImagePath.social5 },
    { key: "telegram", icon: ImagePath.social6 },
    { key: "whatsapp", icon: ImagePath.social7 },
];

// Agar shareUrl ek QR code image hai (api.qrserver.com/.../create-qr-code)
// to usko "link" ki tarah nahi, balki actual image file ki tarah share karna hai.
// (qrserver.com CORS allow nahi karta, isliye ye URL sirf legacy/fallback ke
// liye check hoti hai - asli image ab qrImageDataUrl prop se aati hai.)
const isQrImageUrl = (url = "") =>
    url.includes("qrserver.com") || url.includes("create-qr-code");

// data:image/png;base64,... string ko File object me convert karta hai.
// Ye purely local/synchronous operation hai - koi network request nahi,
// isliye CORS ka koi sawaal hi nahi uthta.
const dataUrlToFile = (dataUrl, filename) => {
    const [meta, base64] = dataUrl.split(",");
    const mimeMatch = meta.match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "image/png";
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return new File([bytes], filename, { type: mime });
};

// Platforms jinke liye web par sirf TEXT/LINK share intent maujood hai
// (koi bhi in web endpoints par image file attach nahi kar sakta - ye
// Facebook/Twitter/Telegram ki apni limitation hai, code se fix nahi ho sakti).
const LINK_ONLY_PLATFORMS = ["facebook", "twitter", "telegram", "email"];

const SharePopup = ({
    isOpen,
    onClose,
    shareUrl,
    qrImageDataUrl, // optional: client-side generated QR (data:image/png;base64,...) - CORS-safe
    message = "",
    title = "Share Marketing Material",              // ✅ static, overridable
    subtitle = "Share this marketing creative with your clients, prospects, or network.", // ✅ static, overridable
    page,
}) => {

    const [copied, setCopied] = useState(false);
    const [qrFile, setQrFile] = useState(null);
    const [refCode, setRefCode] = useState("");
    const isQrShare = Boolean(qrImageDataUrl) || isQrImageUrl(shareUrl);
    console.log("check the page ", page)
    // QR file ko popup khulte hi (click se pehle) ready rakhte hain, taaki
    // navigator.share() click ke andar bina kisi delay ke turant call ho sake
    // (Web Share API sirf ek direct user-gesture ke andar hi kaam karta hai).
    useEffect(() => {

        if (!isOpen) {
            setQrFile(null);
            return;
        }

        if (qrImageDataUrl) {
            // ✅ Preferred path: client-side generated QR, koi fetch/CORS nahi
            try {
                setQrFile(dataUrlToFile(qrImageDataUrl, "bigul-referral-qr.png"));
            } catch (err) {
                console.log("QR data-url convert failed:", err);
                setQrFile(null);
            }
            return;
        }

        if (isQrImageUrl(shareUrl)) {
            // Legacy fallback: server image fetch karne ki koshish (qrserver.com
            // par CORS headers nahi hain, isliye ye aksar fail hoga)
            let cancelled = false;
            fetch(shareUrl)
                .then((res) => res.blob())
                .then((blob) => {
                    if (!cancelled) {
                        setQrFile(new File([blob], "bigul-referral-qr.png", { type: blob.type || "image/png" }));
                    }
                })
                .catch((err) => {
                    console.log("QR prefetch failed (CORS?):", err);
                    setQrFile(null);
                });
            return () => {
                cancelled = true;
            };
        }

        setQrFile(null);
    }, [isOpen, shareUrl, qrImageDataUrl]);
    useEffect(() => {
        if (!shareUrl) return;

        try {
            const url = new URL(shareUrl);

            const code = url.searchParams.get("ref");

            console.log("check the code return", code);

            setRefCode(code || "");

        } catch (error) {
            console.log("QR URL parsing error", error);
            setRefCode("");
        }

    }, [shareUrl]);


    if (!isOpen) return null;

    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText(shareUrl);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.log("Copy failed", err);
        }
    };

    // Referral link se ek PUBLIC QR image URL banata hai (qrserver.com ka
    // free public API - koi auth/hosting nahi chahiye). Ye ek direct image
    // link hai, isliye jahan bhi is URL ko paste/send karoge, click karne
    // par QR seedha open ho jaayega, aur WhatsApp jaise apps isko inline
    // image thumbnail ki tarah preview bhi kar sakte hain.
    const buildQrPublicUrl = (dataText) =>
        `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(
            dataText
        )}`;

    // Jab image share possible na ho (desktop browser jaha File Share support nahi),
    // QR image download kara do taki user manually attach kar sake.
    const downloadQrImage = () => {
        if (!qrImageDataUrl) {
            console.log("QR image not available");
            return;
        }

        const link = document.createElement("a");
        link.href = qrImageDataUrl;
        link.download = "bigul-referral-qr.png";

        document.body.appendChild(link);
        link.click();
        link.remove();
    };

    // Sirf actual mobile devices (Android/iOS) par true - desktop browsers
    // (macOS/Windows) par navigator.share() bhi kaam kar sakta hai, lekin
    // wahan sirf generic OS share sheet khulti hai (AirDrop/Mail/Notes...)
    // jisme WhatsApp option hi nahi hota - isliye desktop par ise skip
    // karke seedha WhatsApp Web par redirect karna behtar hai.
    const isMobileDevice = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    // Native (mobile) file-share ki koshish karta hai - agar successful ho jaye
    // to true return karta hai, warna false (taaki caller fallback kar sake).
    const tryNativeImageShare = () => {
        if (!isMobileDevice()) {
            return false;
        }

        if (window.FlutterShare && typeof window.FlutterShare.postMessage === "function" && qrFile) {
            const reader = new FileReader();
            reader.onloadend = () => {
                window.FlutterShare.postMessage(
                    JSON.stringify({
                        type: "share_image",
                        base64: reader.result,
                        title,
                        text: message || title,
                    })
                );
            };
            reader.readAsDataURL(qrFile);
            return true;
        }

        if (qrFile && navigator.canShare && navigator.canShare({ files: [qrFile] })) {
            navigator
                .share({
                    files: [qrFile],
                    title,
                    text: message || title,
                })
                .catch((err) => console.log("Share cancelled/failed:", err));
            return true;
        }

        return false;
    };

    // const handleShare = () => {
    //     // 1. The target URL containing your Open Graph (og:image) tags
    //     const shareUrl = `https://bcrm.bigul.co/api/share-qr?channel=${encodeURIComponent("BIGUL")}&name=${encodeURIComponent("Narendra")}&ref=${encodeURIComponent(refCode)}`;
    //     // 2. Mobile vs Desktop WhatsApp link
    //     const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    //     const whatsappUrl = isMobile
    //         ? `whatsapp://send?text=${encodeURIComponent(shareUrl)}`
    //         : `https://web.whatsapp.com/send?text=${encodeURIComponent(shareUrl)}`;

    //     window.open(whatsappUrl, '_blank');
    // };
    const handleShare = () => {
        const shareUrl = `https://bcrm.bigul.co/api/share-qr?channel=${encodeURIComponent("BIGUL")}&name=&ref=${encodeURIComponent(refCode)}`;

        const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

        const whatsappUrl = isMobile
            ? `whatsapp://send?text=${encodeURIComponent(shareUrl)}`
            : `https://web.whatsapp.com/send?text=${encodeURIComponent(shareUrl)}`;

        window.open(whatsappUrl, "_blank", "noopener,noreferrer");
    };
    // Platform ke web share intent ko text/link ke saath kholta hai
    // (ye woh hi purana behaviour hai jo referral-link share ke liye tha).
    // Agar qrLink diya gaya hai, to usse message text me QR ke public URL
    // ke roop me jod diya jaata hai, taaki share hone wali jagah par QR
    // bhi ek clickable/openable link ki tarah pahunche.
    const openPlatformLinkShare = (platform, qrLink = "") => {
        const baseMessage = qrLink ? `${message}\n${shareUrl}\nQR Code: ${qrLink}` : `${message} ${shareUrl}`;
        const text = baseMessage.trim();
        const tweetText = qrLink ? `${message}\nQR Code: ${qrLink}`.trim() : message;
        const telegramText = qrLink ? `${message}\nQR Code: ${qrLink}`.trim() : message;

        switch (platform) {
            case "facebook":
                window.open(
                    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                        page == "QA" ? qrImageDataUrl : shareUrl
                    )}&quote=${encodeURIComponent(qrLink ? `${message} QR Code: ${qrLink}` : message)}`,
                    "_blank",
                    "noopener,noreferrer"
                );
                break;
            case "email":
                window.location.href = `mailto:?subject=${encodeURIComponent(
                    "Check this out"
                )}&body=${encodeURIComponent(page == "QR" ? qrImageDataUrl : text)}`;
                break;
            case "twitter":
                window.open(
                    `https://twitter.com/intent/tweet?text=${encodeURIComponent(
                        tweetText
                    )}&url=${encodeURIComponent(page == "QR" ? qrImageDataUrl : shareUrl)}`,
                    "_blank",
                    "noopener,noreferrer"
                );
                break;
            case "instagram":
                navigator.clipboard?.writeText(page == "QR" ? qrImageDataUrl : text).catch(() => { });
                window.open("https://www.instagram.com/", "_blank", "noopener,noreferrer");
                break;
            case "youtube":
                navigator.clipboard?.writeText(page == "QR" ? qrImageDataUrl : text).catch(() => { });
                window.open("https://www.youtube.com/", "_blank", "noopener,noreferrer");
                break;
            case "telegram":
                window.open(
                    `https://t.me/share/url?url=${encodeURIComponent(
                        page == "QR" ? qrImageDataUrl : shareUrl
                    )}&text=${encodeURIComponent(telegramText)}`,
                    "_blank",
                    "noopener,noreferrer"
                );
                break;
            case "whatsapp":
                console.log("::::::::::::::::::", page)
                page = "CLient" ?
                    window.open(
                        // `https://wa.me/?text=${encodeURIComponent(page == "QA" ? qrImageDataUrl : text)}`,
                        `https://wa.me/?text=${encodeURIComponent(text)}`,
                        "_blank",
                        "noopener,noreferrer"
                    )
                    :
                    handleShare();
                break;
            default:
                break;
        }
    };

    const handleSocialShare = (platform) => {
        // ✅ QR code case: link text share karne ke bajaye actual QR image
        // share karne ki koshish karo (jaha technically possible hai).
        if (isQrShare) {

            // WhatsApp: pehle native/file share try karo (mobile par isse
            // seedha WhatsApp app tak image jaati hai agar user select kare).
            // Agar file-share support nahi hai (jyadatar desktop browsers),
            // to WhatsApp ka web/app link text ke saath khol do aur QR
            // download kara do taaki user manually attach kar sake.
            // if (platform === "whatsapp") {
            //     const shared = tryNativeImageShare();
            //     if (!shared) {
            //         openPlatformLinkShare("whatsapp");
            //         downloadQrImage();
            //     }
            //     return;
            // }
            if (platform === "whatsapp") {
                handleShare();
                return;
            }

            // Facebook / Twitter / Telegram / Email: inke web share
            // endpoints image attach nahi kar sakte (platform limitation,
            // in web URLs me koi image param nahi hota). Isliye respective
            // platform link/text ke saath khol do, aur QR image alag se
            // download kara do taaki user use manually attach kar sake.
            if (LINK_ONLY_PLATFORMS.includes(platform)) {
                openPlatformLinkShare(platform);
                downloadQrImage();
                return;
            }

            // Instagram / YouTube: koi direct web-share intent nahi hota,
            // isliye link copy karke platform site khol do (purana behaviour),
            // aur QR bhi download kara do.
            openPlatformLinkShare(platform);
            downloadQrImage();
            return;
        }

        // Normal referral link share (purana behaviour, isse koi change nahi)
        openPlatformLinkShare(platform);
    };

    const content = (
        <div className="share-popup-overlay" onClick={onClose}>
            <div className="share-popup" onClick={(e) => e.stopPropagation()}>
                <button className="share-popup-close" onClick={onClose}>
                    &times;
                </button>
                <div className="icon">
                    <img src={ImagePath.share_icon} alt="" />
                </div>
                <h3>{title}</h3>
                <p>{subtitle}</p>
                <div className="form-group">
                    <input type="text" className="form-control" value={shareUrl} readOnly />
                    <button className="btun" onClick={handleCopyLink}>
                        {copied ? "Copied" : "Copy Link"}
                    </button>
                </div>
                <p>Or share via</p>
                <ul>
                    {socialPlatforms.map(({ key, icon }) => (
                        <li key={key}>
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleSocialShare(key);
                                }}
                            >
                                <img src={icon} alt={key} />
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div >
    );

    return ReactDOM.createPortal(content, document.body);
};

export default SharePopup;